<div class="tenant-base">
  <a href="javascript:void(0)" class="back-link" (click)="goBack()">
    <i class="bi bi-chevron-left"></i> Back to Tenants
  </a>

  @if (loading) {
    <div class="loading-container">
      <app-loader />
    </div>
  } @else if (tenant) {
    <h2 class="page-title">{{ tenant.name }}</h2>
    <p class="page-subtitle">Tenant overview and configuration</p>

    <div class="section-grid">
      @for (card of cards; track card.key) {
        <div class="section-card" (click)="onCardClick(card.key)">
          <div class="section-icon">
            <i [class]="'bi ' + card.icon"></i>
          </div>
          <div class="section-title">{{ card.title }}</div>
          <div class="section-description">{{ card.description }}</div>
          <div class="section-footer">{{ card.footer }}</div>
        </div>
      }
    </div>
  }
</div>
